// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GQMIu{display:flex;align-items:center;gap:4px}.rO1ZP{padding-left:28px;display:flex;align-items:center;gap:8px;margin-top:16px}.zkF_R{margin-top:16px;height:40px}.zodxb{display:flex;flex-direction:row;align-items:center;gap:15px;width:100%}.MzZRK{display:flex;flex-direction:row;align-items:center;gap:7px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"optionalInlineSelectContainer": `GQMIu`,
	"additionalControl": `rO1ZP`,
	"roundPrices": `zkF_R`,
	"rowAndIconContainer": `zodxb`,
	"rowContent": `MzZRK`
};
export default ___CSS_LOADER_EXPORT___;
